// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetStatusHistoryDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetStatusHistoryApiClient extends BaseCRUDApiClient<AssetStatusHistoryDto> {
  baseUrl = this.config.apiEndpoint + '/asset-status-history';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
